export default __webpack_public_path__ + "static/ethan-dobbins-soundly-e2e0d357d374310294de8ec4bda6e3f3.mp4";